import { EventRepository } from '../../internal/repositories/EventRepository';
import { events, query, serviceQueries } from '@estee/elc-service-bus';
import { diContainer, serviceNames } from '../../service-setup/diContainer';
import { Event } from '../domain/entities/Event';
import { IOrderQueryData } from '../../service-setup/ServiceBusController';

export class TransactionFailedUseCase {
    private eventRepository: EventRepository;
    private orderQueryData: IOrderQueryData;
    private error: string;

    constructor(orderQueryData: IOrderQueryData, error?: string) {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        this.orderQueryData = orderQueryData;
        this.error = error || '';
    }

    public execute = async () => {
        // TODO: can retrieval of this order data be moved to DataAggregator? Or can it be passed in?
        const totalCountOfOrders = await query(serviceQueries.TOTAL_COUNT_OF_ORDERS);
        const orderQuery = await query(serviceQueries.GET_ORDER_DATA, this.orderQueryData);

        const { order } = orderQuery;
        const event_label = 'event_label';

        // eslint-disable-next-line  @typescript-eslint/no-explicit-any
        const event_info: any = {
            event_name: 'transaction_fail',
            event_category: 'ecommerce',
            event_action: 'transaction fail'
        };

        if (this.error) {
            event_info[event_label] = this.error;
        }

        const transactionFailedPayload = {
            order_currency_code: order.currency.isoCode,
            order_discount_amount: order.totals.totalDiscounts,
            order_grand_total: order.totals.totalWithTax,
            order_id: order.id,
            order_merchandise_total: order.totals.subTotalWithTax,
            order_payment_type: this.orderQueryData.paymentType,
            order_shipping_amount: order.shippingInfo[0].priceWithTax,
            order_subtotal: order.totals.subTotalWithTax,
            order_tax_amount: order.totals.tax,
            order_total_product_units: order.items.length,
            order_type: order.orderType,
            orders_compare: '',
            orders_count: totalCountOfOrders,
            orders_total: order.totals.subTotalWithTax,
            ...event_info
        };

        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: events.TRANSACTION_FAILED,
            type: 'link',
            payload: transactionFailedPayload
        });

        this.eventRepository.addEventToQueue(newEvent);
    };
}
